
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Tempotravelleeronrentinpune() {



    const cardData =
    {
        keyword: 'Tempo Traveller on Rent Pune',
        heading: 'Meghana Cab : Tempo Traveller on Rent Pune',
        headingDescription: 'Meghana Cab offers Tempo Traveller on Rent in Pune, perfect for group outings, family vacations, corporate tours, and pilgrimage trips. Our tempo travellers are available in multiple seating options—14, 17, 20, and 26 seaters—equipped with pushback seats, ample luggage space, air conditioning, and a comfortable interior to ensure a relaxed travel experience for all passengers. Whether you are planning a local Pune tour or an outstation journey to destinations like Shirdi, Mahabaleshwar, Goa, or Lonavala, our professional drivers and well-maintained vehicles guarantee safety and punctuality. Book your Tempo Traveller in Pune with Meghana Cab for a smooth, spacious, and affordable group travel experience.',


        top: 'Top Places to Visit in Pune with Meghana Cab',

"topPlaces": [
   {
    "title": "Osho Ashram (Meditation Resort)",
    "description": "Nestled in lush Koregaon Park, this global meditation centre promotes wellness through guided meditations, yoga, therapies, and silent retreats. Housed in serene halls with beautifully maintained gardens, it provides a space for introspection and rejuvenation." 
  },
    {
    "title": "Sinhagad Fort",
    "description": "Perched at 1,317 m on the Sahyadri range, this ancient hill fortress—famed for the 1670 Battle of Sinhagad—offers rugged treks, two main gateways (Pune & Kalyan Darwaza), Tanaji Malusare’s memorial, and sweeping vistas of the Deccan Plateau. It’s a beloved weekend trek with food stalls serving local fare." 
  },
    {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 as the seat of the Maratha Peshwas, this iconic fortification features grand teak gateways, granite walls, ornate fountains, and remnants of its former glory. Despite a destructive fire in 1828, the five surviving gates—like the Delhi and Mastani Darwaza—and the palace ruins offer a journey into Maratha power and intrigue, often brought to life during the evening light-and-sound show." 
  },
  {
    "title": "Aga Khan Palace",
    "description": "Constructed in 1892 with Italian arches and set amidst sprawling lawns, this palatial structure served both famine relief and later the Indian freedom struggle—Mahatma Gandhi and his family were interned here. Now a museum, it preserves Gandhi’s personal items and the samadhis of Kasturba Gandhi and Mahadev Desai, echoing India’s fight for independence." 
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "An 8th‑century monolithic rock‑cut Shiva temple carved from basalt, this subterranean sanctum includes a circular Nandi mandapa with intricately carved pillars and a unique ‘underworld’ symbolism, all nestled within a peaceful urban heritage setting." 
  },
  {
    "title": "Dagdusheth Halwai Ganapati Temple",
    "description": "One of Pune’s most celebrated sacred sites, this temple houses a lavishly adorned gold Ganesh idol and draws devotees year‑round. During Ganesh Chaturthi, its vibrant rituals, processions, and communal spirit make it a cultural highlight." 
  },
  {
    "title": "Parvati Hill & Temple",
    "description": "Pune’s second‑highest hill at ~2,100 ft, crowned by the historic Peshwa-era Parvati Temple. A 103-step climb rewards visitors with rooftop city views, a small museum, and serene gardens—popular at sunrise and for spiritual solace." 
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Housing 20,000+ artifacts—ranging from decorative arts to musical instruments—this museum offers a vivid window into daily life in historical India. It recently introduced geofenced multilingual audio guides across its eight galleries. " 
  },
  {
    "title": "Shinde Chhatri",
    "description": "A memorial dedicated to Maratha warrior Mahadji Shinde (d.1794), featuring Rajasthani-style carved pavilions, colored glass windows, and serene courtyards. It marks both his cremation spot and enduring legacy." 
  },
  {
    "title": "Rajiv Gandhi Zoological Park (Katraj Zoo)",
    "description": "Spanning 130 acres at Pune’s edge, this family-friendly park includes a zoo, snake park, aviary, and botanical sections. It combines wildlife conservation with educational exhibits and picnic spaces." 
  }
],

"services": [
  {
    "name": "Tempo Traveller Hire in Pune",
    "description": "Hire a spacious and reliable Tempo Traveller in Pune for group travel, tours, or special occasions. Our fleet offers clean interiors, ample luggage space, and experienced drivers to ensure a safe and enjoyable journey for all passengers."
  },
  {
    "name": "Book Tempo Traveller Pune",
    "description": "Easily book a Tempo Traveller in Pune for any kind of group travel — be it leisure, corporate, or family trips. Our booking process is quick, transparent, and customer-friendly with customizable travel packages to suit your itinerary."
  },
  {
    "name": "12-Seater Tempo Traveller Pune",
    "description": "Choose our 12-seater Tempo Traveller in Pune for small group tours, airport transfers, or business outings. With comfortable seats, AC, and professional drivers, this is an ideal vehicle for groups seeking a budget-friendly yet cozy ride."
  },
  {
    "name": "17-Seater Tempo Traveller Rent Pune",
    "description": "Need extra space for larger groups? Our 17-seater Tempo Traveller in Pune is perfect for school trips, extended families, or team outings. Enjoy a spacious cabin, efficient cooling, and top-notch comfort for every mile of the trip."
  },
  {
    "name": "AC Tempo Traveller Pune",
    "description": "Beat the heat with our fully air-conditioned Tempo Travellers in Pune. Whether you're heading outstation or touring the city, these vehicles offer excellent ventilation, recliner seating, and ample legroom to make group travel comfortable."
  },
  {
    "name": "Pune to Outstation Tempo Traveller",
    "description": "Plan stress-free outstation trips from Pune with our long-distance Tempo Traveller services. Our vehicles are well-maintained, feature reclining seats, and come with experienced drivers who ensure timely and safe travel to any destination."
  },
  {
    "name": "Pune Airport Tempo Traveller Rental",
    "description": "Make airport group pickups and drop-offs easy with our Tempo Traveller rentals in Pune. Ideal for families, wedding parties, and corporate groups arriving together, our service ensures timely transfers with comfort and professionalism."
  },
  {
    "name": "Wedding Tempo Traveller in Pune",
    "description": "Need transportation for wedding guests in Pune? Our Tempo Travellers are perfect for shuttling guests between venues. Clean, comfortable, and spacious, they ensure your friends and family travel together with ease and elegance."
  },
  {
    "name": "Corporate Tempo Traveller Hire Pune",
    "description": "Ensure smooth business group travel with our corporate Tempo Traveller services in Pune. With punctual drivers and professional service, we help companies manage employee or client transportation with class and convenience."
  },
  {
    "name": "Group Travel Tempo Traveller Pune",
    "description": "Whether you're touring nearby attractions or heading outstation, our group Tempo Traveller cabs in Pune are tailored for collective comfort. Spacious interiors, AC, and audio systems make it perfect for social travel experiences."
  },
  {
    "name": "Luxury Tempo Traveller Pune",
    "description": "Upgrade your group travel experience with our luxury Tempo Travellers in Pune. Featuring plush seats, mood lighting, entertainment systems, and premium interiors, this is perfect for those who want to ride in style with friends or colleagues."
  },
  {
    "name": "Online Booking Tempo Traveller Pune",
    "description": "Book your Tempo Traveller online in Pune with just a few clicks. Our digital platform is user-friendly, secure, and offers instant confirmations, allowing you to plan group trips with clarity and convenience."
  },
  {
    "name": "Budget Tempo Traveller Rental Pune",
    "description": "Looking for a cost-effective group travel solution? Our budget Tempo Traveller rentals in Pune provide value-for-money service without compromising comfort or safety, ideal for school tours, pilgrimages, or family reunions."
  },
  {
    "name": "School Trip Tempo Traveller Pune",
    "description": "Organize safe and comfortable transportation for students with our school trip Tempo Travellers in Pune. With verified drivers and child-friendly features, we ensure a worry-free journey for both school staff and parents."
  },
  {
    "name": "Family Outing Tempo Traveller Pune",
    "description": "Make your family outings memorable with our Tempo Traveller service in Pune. Whether it's a weekend getaway or a festive gathering, our vehicles ensure the whole family travels together comfortably and safely."
  }
],
"tableData": [
  ["Tempo Traveller Hire in Pune", "Book Tempo Traveller Pune"],
  ["12-Seater Tempo Traveller Pune", "17-Seater Tempo Traveller Rent Pune"],
  ["AC Tempo Traveller Pune", "Pune to Outstation Tempo Traveller"],
  ["Pune Airport Tempo Traveller Rental", "Wedding Tempo Traveller in Pune"],
  ["Corporate Tempo Traveller Hire Pune", "Group Travel Tempo Traveller Pune"],
  ["Luxury Tempo Traveller Pune", "Online Booking Tempo Traveller Pune"],
  ["Budget Tempo Traveller Rental Pune", "School Trip Tempo Traveller Pune"],
  ["Family Outing Tempo Traveller Pune", ""]
],







"whychoose": [
    {
        "WhyChooseheading": "Spacious Tempo Traveller Rentals in Pune",
        "WhyChoosedescription": "Meghana Cab offers comfortable and spacious Tempo Traveller rentals in Pune, perfect for large groups, family trips, corporate outings, and pilgrimages. Our vehicles comfortably accommodate up to 12-15 passengers, providing ample legroom and luggage space for a relaxed journey."
    },
    {
        "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
        "WhyChoosedescription": "All our Tempo Travellers are regularly serviced and thoroughly sanitized to ensure the highest standards of safety and hygiene. Equipped with air-conditioning and comfortable seating, they offer a clean and pleasant travel environment for all passengers."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our skilled drivers are well-versed with Pune’s routes and traffic conditions, ensuring timely pickups and safe journeys. They provide courteous service, prioritize passenger comfort, and navigate efficiently to avoid delays."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "We offer competitive and transparent pricing for Tempo Traveller rentals, including fuel, tolls, driver allowances, and taxes. No hidden charges guarantee a hassle-free booking experience tailored to your budget."
    },
    {
        "WhyChooseheading": "Flexible Booking Options for Various Needs",
        "WhyChoosedescription": "Whether you need a Tempo Traveller for a day trip, multiple days, or special events, our rental options are flexible. Customize your itinerary with preferred pickup and drop locations, stops, and travel schedules to suit your group’s requirements."
    },
    {
        "WhyChooseheading": "Ideal for Large Groups and Special Occasions",
        "WhyChoosedescription": "Our Tempo Travellers are perfect for large families, friend groups, corporate team outings, weddings, and religious pilgrimages. Enjoy group travel with comfort, convenience, and safety throughout your journey."
    },
    {
        "WhyChooseheading": "24/7 Booking Support and Customer Assistance",
        "WhyChoosedescription": "Book your Tempo Traveller anytime with our round-the-clock customer support. Our team is always available to help with reservations, changes, or special requests, ensuring a smooth and seamless rental experience."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Group Travel",
        "WhyChoosedescription": "Safety and comfort are our top priorities. Our Tempo Travellers are equipped with seat belts and driven by professional drivers who follow all safety protocols, making your group travel secure and enjoyable."
    }
]





























    }

const faqData = [
    {
        question: "How can I rent a Tempo Traveller in Pune with Meghana Cab?",
        answer: "You can book a Tempo Traveller by calling Meghana Cab at +91 9075462128 or via our website for quick and easy rental."
    },
    {
        question: "What is the seating capacity of your Tempo Travellers?",
        answer: "Our Tempo Travellers comfortably seat between 12 to 15 passengers, perfect for family or group trips."
    },
    {
        question: "Are Meghana Cab drivers experienced in driving Tempo Travellers?",
        answer: "Yes, our drivers are skilled and experienced in handling Tempo Travellers for a safe and smooth journey."
    },
    {
        question: "Is the Tempo Traveller available for both local and outstation trips?",
        answer: "Yes, you can rent Tempo Travellers for local Pune trips as well as outstation journeys."
    },
    {
        question: "Does the rental fare include fuel, tolls, and driver charges?",
        answer: "Our rental charges include fuel, tolls, and driver fees. Additional waiting time or parking fees may apply."
    },
    {
        question: "Are the Tempo Travellers sanitized before every trip?",
        answer: "Absolutely, all vehicles are thoroughly sanitized before each trip to ensure passenger safety."
    },
    {
        question: "Is the Tempo Traveller rental service available 24/7 in Pune?",
        answer: "Yes, Meghana Cab offers 24/7 Tempo Traveller rental services to meet your schedule."
    },
    {
        question: "Can I request stops for meals or sightseeing during the trip?",
        answer: "Yes, halts can be arranged upon request. Please inform us at the time of booking."
    },
    {
        question: "What payment methods are accepted for Tempo Traveller rentals?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash."
    },
    {
        question: "How do I contact Meghana Cab to rent a Tempo Traveller in Pune?",
        answer: "Call us anytime at +91 9075462128 to book your Tempo Traveller or get assistance."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Amit Deshmukh',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Renting a Tempo Traveller from Meghana Cab was perfect for our family trip. Spacious and comfortable vehicle.”',
    },
    {
        name: 'Mrs. Sunita Patil',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Excellent service and a clean Tempo Traveller. The driver was professional and helpful.”',
    },
];














































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];







const cabServiceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "@id": "https://www.meghanacabs.com/tempo-traveller-on-rent-in-pune#service",
  "serviceType": "Tempo Traveller on Rent in Pune",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com/"
  },
  "areaServed": ["Pune","Pimpri-Chinchwad","Pune Airport (PNQ)","Lonavala","Mahabaleshwar","Mumbai","Shirdi","Goa","Maharashtra"],
  "description": "Tempo Traveller rental in Pune for group tours, corporate trips, school/college outings, and airport transfers. AC Luxury 12, 17, 20, 26, 32 seater options with verified drivers and transparent pricing.",
  "offers": {
    "@type": "AggregateOffer",
    "priceCurrency": "INR",
    "lowPrice": "2499",
    "highPrice": "19999",
    "offerCount": "15",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/tempo-traveller-on-rent-in-pune"
  },
  "aggregateRating": { "@type": "AggregateRating", "ratingValue": "4.9", "ratingCount": 7921 }
};

const offerCatalogSchema = {
  "@context": "https://schema.org",
  "@type": "OfferCatalog",
  "name": "Tempo Traveller Variants",
  "itemListElement": [
    { "@type": "Offer", "name": "12 Seater Tempo Traveller (AC)", "priceCurrency": "INR", "price": "2499", "url": "https://www.meghanacabs.com/tempo-traveller-on-rent-in-pune#12-seater" },
    { "@type": "Offer", "name": "17 Seater Tempo Traveller (AC)", "priceCurrency": "INR", "price": "3299", "url": "https://www.meghanacabs.com/tempo-traveller-on-rent-in-pune#17-seater" },
    { "@type": "Offer", "name": "20 Seater Tempo Traveller (AC)", "priceCurrency": "INR", "price": "3899", "url": "https://www.meghanacabs.com/tempo-traveller-on-rent-in-pune#20-seater" },
    { "@type": "Offer", "name": "26 Seater Tempo Traveller (AC)", "priceCurrency": "INR", "price": "4899", "url": "https://www.meghanacabs.com/tempo-traveller-on-rent-in-pune#26-seater" },
    { "@type": "Offer", "name": "32 Seater Tempo Traveller (AC/Luxury)", "priceCurrency": "INR", "price": "5999", "url": "https://www.meghanacabs.com/tempo-traveller-on-rent-in-pune#32-seater" }
  ]
};

const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": "https://www.meghanacabs.com/#biz",
  "name": "Meghana Cabs",
  "url": "https://www.meghanacabs.com/",
  "image": "https://www.meghanacabs.com/assets/images/tempo-traveller-on-rent-in-pune.jpg",
  "priceRange": "₹₹",
  "address": { "@type": "PostalAddress", "addressLocality": "Pune", "addressRegion": "MH", "addressCountry": "IN" },
  "areaServed": ["Pune","PCMC","Maharashtra","Goa","Karnataka"],
  "openingHoursSpecification": [{ "@type": "OpeningHoursSpecification", "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"], "opens": "00:00", "closes": "23:59" }],
  "aggregateRating": { "@type": "AggregateRating", "ratingValue": "4.8", "ratingCount": 8463 }
};

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.meghanacabs.com/" },
    { "@type": "ListItem", "position": 2, "name": "Tempo Traveller on Rent in Pune", "item": "https://www.meghanacabs.com/tempo-traveller-on-rent-in-pune" }
  ]
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    { "@type": "Question", "name": "Which seat options are available?", "acceptedAnswer": { "@type": "Answer", "text": "We offer AC Tempo Travellers in 12, 17, 20, 26, and 32 seater variants. Choose based on group size and luggage." }},
    { "@type": "Question", "name": "Are prices fixed and all-inclusive?", "acceptedAnswer": { "@type": "Answer", "text": "Yes—transparent fares shared upfront. Tolls, parking, and state taxes are shown clearly; no hidden charges." }},
    { "@type": "Question", "name": "Do you support outstation and multi-day trips?", "acceptedAnswer": { "@type": "Answer", "text": "Yes—popular routes include Mahabaleshwar, Lonavala, Shirdi, Kolhapur, Mumbai, Goa, and custom itineraries with driver night allowance." }},
    { "@type": "Question", "name": "Is the service 24x7?", "acceptedAnswer": { "@type": "Answer", "text": "Yes—early morning and late-night departures supported. On-time pickup with verified professional drivers." }}
  ]
};



    return (
        <div>


<Helmet>
  <title>Tempo Traveller on Rent in Pune | 12, 17, 20, 26, 32 Seater | Meghana Cabs</title>
  <meta
    name="description"
    content="Hire Tempo Traveller in Pune for group travel—AC Luxury 12/17/20/26/32 seater. Perfect for outstation trips, corporate events, school tours, and airport transfers. Transparent fares & 24x7 support."
  />
  <link rel="canonical" href="https://www.meghanacabs.com/tempo-traveller-on-rent-in-pune" />
  <meta name="robots" content="index,follow,max-snippet:-1,max-image-preview:large,max-video-preview:-1" />

  {/* Optional meta keywords */}
  <meta
    name="keywords"
    content="Tempo Traveller on Rent in Pune, 12 Seater Tempo Traveller Pune, 17 Seater Tempo Traveller Pune, 20 Seater TT Pune, 26 Seater Tempo Traveller Pune, 32 Seater Luxury Tempo Traveller Pune, Outstation Tempo Traveller Pune"
  />

  {/* Open Graph */}
  <meta property="og:type" content="website" />
  <meta property="og:title" content="Tempo Traveller on Rent in Pune | Meghana Cabs" />
  <meta
    property="og:description"
    content="AC Luxury Tempo Traveller rentals in Pune—12/17/20/26/32 seater for group tours and outstation travel."
  />
  <meta property="og:url" content="https://www.meghanacabs.com/tempo-traveller-on-rent-in-pune" />
  <meta property="og:image" content="https://www.meghanacabs.com/assets/images/tempo-traveller-on-rent-in-pune.jpg" />

  {/* Twitter */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Tempo Traveller on Rent in Pune | Meghana Cabs" />
  <meta
    name="twitter:description"
    content="Rent 12–32 seater Tempo Travellers in Pune for outstation & events. Transparent fares, verified drivers."
  />
  <meta name="twitter:image" content="https://www.meghanacabs.com/assets/images/tempo-traveller-on-rent-in-pune.jpg" />

  {/* JSON-LD */}
  <script type="application/ld+json">{JSON.stringify(cabServiceSchema)}</script>
  <script type="application/ld+json">{JSON.stringify(offerCatalogSchema)}</script>
  <script type="application/ld+json">{JSON.stringify(localBusinessSchema)}</script>
  <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
  <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
</Helmet>



            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/53.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Tempotravelleeronrentinpune;